import { Component } from '@angular/core';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { MatDialogModule, MatDialog } from '@angular/material/dialog';
import { DataService } from '../services/data.service';
import { CommonModule } from '@angular/common';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { SendMailModalComponent } from '../send-mail-modal/send-mail-modal.component';
import { RecaptchaService } from '../services/recaptcha.service';
import { LambdaService } from '../services/lambda.service';


@Component({
  selector: 'app-send-links-header',
  standalone: true,
  imports: [MatProgressSpinnerModule, MatDialogModule, CommonModule, NgxSkeletonLoaderModule],
  templateUrl: './send-links-header.component.html',
  styleUrl: './send-links-header.component.css'
})
export class SendLinksHeaderComponent {

  get isLoading() { return this.dataService.loading; }
  get censoredEmail() { return this.dataService.customer?.censoredEmail; }

  constructor(
    private dataService: DataService,
    private dialog: MatDialog,
    private recaptcha: RecaptchaService,
    private lambdaService: LambdaService,
  ) {}

  async sendMail() {
    // llamar al backend
    const token_sendPaymentData = await this.recaptcha.execute('sendPaymentData');
    await this.lambdaService.invokeSendPaymentsData(this.dataService.customer.id, token_sendPaymentData);
  }

  openDialog() {
    if (this.isLoading) return;

    this.sendMail();

    const ref = this.dialog.open(SendMailModalComponent, {
      width: '600px',
      data: { censoredMail: this.censoredEmail }
    });

    ref.afterClosed().subscribe(result => {
      if (result === 'redirect') {
        window.location.href = 'https://www.totalabogados.cl';
      }
      if (result === 'resend') {
        // wait 1 second
        setTimeout(() => { this.openDialog(); }, 300);
      }
    });
  }

}
